/* ==========================================================================
   Hypocall — Calculadora, Mapa Mental e Mapa de Clientes
   Portado do projeto build-guard-block (React) para JS puro.
   Cada bloco é inicializado por data-attribute e reinicializado quando a
   seção é recarregada no editor de temas (shopify:section:load).
   ========================================================================== */
(function () {
  if (window.Hypocall) return;

  /* ---------------- Utils ---------------- */

  function formatCurrency(value) {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 });
  }

  function parseCurrencyInput(value) {
    var digits = String(value).replace(/\D/g, '');
    return Number(digits || '0') / 100;
  }

  function formatCurrencyInput(value) {
    return parseCurrencyInput(value).toLocaleString('pt-BR', {
      style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2
    });
  }

  function formatWeight(value) {
    if (Math.abs(value) >= 1000) return (value / 1000).toFixed(2).replace('.', ',') + ' TON';
    return Math.round(value).toLocaleString('pt-BR') + ' kg';
  }

  function formatDays(value) {
    return value.toFixed(0) + ' dias';
  }

  function maskPhone(raw) {
    var d = String(raw).replace(/\D/g, '').slice(0, 11);
    if (d.length <= 2) return d;
    if (d.length <= 6) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
    return '(' + d.slice(0, 2) + ') ' + d.slice(2, d.length - 4) + '-' + d.slice(-4);
  }

  function whatsappUrl(number, message) {
    return 'https://wa.me/' + String(number).replace(/\D/g, '') + '?text=' + encodeURIComponent(message);
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function onVisible(el, cb, rootMargin) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.disconnect(); cb(); }
      });
    }, { rootMargin: rootMargin || '0px' });
    io.observe(el);
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.dataset.loaded) return resolve();
        existing.addEventListener('load', function () { resolve(); });
        existing.addEventListener('error', reject);
        return;
      }
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () { s.dataset.loaded = '1'; resolve(); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function loadStyle(href) {
    if (document.querySelector('link[href="' + href + '"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = href;
    document.head.appendChild(l);
  }

  /* ---------------- Formulário consultor (cidade/estado IBGE) ---------------- */

  var ibgeStatesPromise = null;
  function fetchIbgeStates() {
    if (!ibgeStatesPromise) {
      ibgeStatesPromise = fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
        .then(function (r) { if (!r.ok) throw new Error('ibge-states'); return r.json(); })
        .catch(function (err) { ibgeStatesPromise = null; throw err; });
    }
    return ibgeStatesPromise;
  }

  function fetchIbgeCities(uf) {
    return fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados/' + uf + '/municipios?orderBy=nome')
      .then(function (r) { if (!r.ok) throw new Error('ibge-cities'); return r.json(); });
  }

  function initConsultor(root) {
    if (root.dataset.hycReady) return;
    root.dataset.hycReady = '1';

    var number = root.dataset.whatsapp;
    var f = function (name) { return root.querySelector('[data-field="' + name + '"]'); };
    var stateSel = f('estado');
    var citySel = f('cidade');
    var phone = f('telefone');
    var send = root.querySelector('[data-hyc-send]');

    phone.addEventListener('input', function () { phone.value = maskPhone(phone.value); });

    function loadCities(uf) {
      citySel.disabled = true;
      citySel.innerHTML = '<option value="">Carregando cidades...</option>';
      fetchIbgeCities(uf).then(function (cities) {
        citySel.innerHTML = cities.map(function (c) {
          return '<option value="' + escapeHtml(c.nome) + '">' + escapeHtml(c.nome) + '</option>';
        }).join('');
        citySel.disabled = cities.length === 0;
      }).catch(function () {
        citySel.innerHTML = '<option value="">Não foi possível carregar as cidades</option>';
      });
    }

    function loadStates() {
      fetchIbgeStates().then(function (states) {
        stateSel.innerHTML = states.map(function (s) {
          return '<option value="' + s.sigla + '">' + escapeHtml(s.nome) + ' (' + s.sigla + ')</option>';
        }).join('');
        stateSel.disabled = false;
        stateSel.value = states.some(function (s) { return s.sigla === 'SP'; }) ? 'SP' : (states[0] && states[0].sigla) || '';
        if (stateSel.value) loadCities(stateSel.value);
      }).catch(function () {
        stateSel.innerHTML = '<option value="">Não foi possível carregar os estados</option>';
      });
    }

    stateSel.addEventListener('change', function () {
      if (stateSel.value) loadCities(stateSel.value);
    });

    send.addEventListener('click', function () {
      var v = function (name) { return f(name).value.trim(); };
      var msg = [
        'Ola, equipe Hypocall.',
        'Nome: ' + (v('nome') || 'Nao informado'),
        'Telefone: ' + (v('telefone') || 'Nao informado'),
        'Empresa: ' + (v('empresa') || 'Nao informada'),
        'Cargo: ' + (v('cargo') || 'Nao informado'),
        'Email: ' + (v('email') || 'Nao informado'),
        'Cidade/Estado: ' + v('cidade') + '/' + v('estado'),
        'Solicitacao: falar com consultor local.'
      ].join('\n');
      window.open(whatsappUrl(number, msg), '_blank', 'noopener,noreferrer');
    });

    // Só busca os estados quando o formulário aparece na tela
    onVisible(root, loadStates);
  }

  /* ---------------- Toggle (mostrar/ocultar formulário) ---------------- */

  function initToggle(btn) {
    if (btn.dataset.hycReady) return;
    btn.dataset.hycReady = '1';
    var target = document.getElementById(btn.dataset.hycToggle);
    if (!target) return;
    var labelOpen = btn.dataset.labelOpen;
    var labelClosed = btn.dataset.labelClosed;
    btn.addEventListener('click', function () {
      var willShow = target.hidden;
      target.hidden = !willShow;
      btn.setAttribute('aria-expanded', String(willShow));
      if (labelOpen && labelClosed) {
        var span = btn.querySelector('[data-label]') || btn;
        span.textContent = willShow ? labelOpen : labelClosed;
      }
    });
  }

  /* ---------------- Calculadora ---------------- */

  var PORTES = {
    casa_pequena: { label: 'Baixo padrão', faixa: [100, 150], sugestao: 125 },
    casa_media: { label: 'Medio Padrão', faixa: [300, 350], sugestao: 325 },
    casa_grande: { label: 'Alto padrão', faixa: [600, 1200], sugestao: 900 },
    predio_pequeno: { label: 'Predio Pequeno', faixa: [1600, 2500], sugestao: 2050 },
    predio_maior: { label: 'Predio Médio', faixa: [12500, 15000], sugestao: 13750 },
    predio_gigante: { label: 'Edificios', faixa: [40000, 50000], sugestao: 45000 }
  };

  var METODOS = {
    trad_cal_imper: 'Cal + Impermeabilizante',
    cal_imper_plast: 'Cal + Impermeabilizante + Plastificante',
    plast_imper: 'Plastificante + Impermeabilizante'
  };

  /*
   * Base da simulação (briefing do site v1.0 / Hypocall v2.3):
   * - Traço 1:8: com Hypocall, 5 sacos de cimento viram 4 (fator 0,8).
   * - Dose: 200 ml de Hypocall por saco de cimento de 50 kg (~0,2 kg).
   * - Preço do Hypocall por saco: varejo, pela embalagem que atende o volume.
   * - Método tradicional completo: R$ 42,00 de aditivos por saco de cimento.
   * - Para 25 sacos, ~557 kg de cal + plastificante + impermeabilizante (22,28 kg/saco).
   * - Produtividade: +15% nas etapas de argamassa.
   * Os valores de aditivos dos outros métodos e o preço do cimento são editáveis.
   */
  var FATOR_CIMENTO_HYPO = 0.8;
  var PRODUTIVIDADE_HYPO = 1.15;
  var SACOS_POR_DIA = 27;
  var PESO_SACO_CIMENTO = 50;
  var PESO_DOSE_HYPO = 0.2;

  var EMBALAGENS = [
    { min: 1000, nome: 'Tambor 200 L', porSaco: 31.38 },
    { min: 250, nome: 'Barril 50 L', porSaco: 32.49 },
    { min: 100, nome: 'Barrica 20 L', porSaco: 33.60 },
    { min: 25, nome: 'Galão 5 L', porSaco: 36.00 },
    { min: 5, nome: 'Garrafa 1 L', porSaco: 36.41 },
    { min: 0, nome: 'Garrafinha 200 ml', porSaco: 36.92 }
  ];

  // Peso dos aditivos por saco de cimento, em kg
  var PESO_ADITIVOS = {
    trad_cal_imper: 22,
    cal_imper_plast: 22.28,
    plast_imper: 2.1
  };

  function embalagemPara(sacos) {
    for (var i = 0; i < EMBALAGENS.length; i++) {
      if (sacos >= EMBALAGENS[i].min) return EMBALAGENS[i];
    }
    return EMBALAGENS[EMBALAGENS.length - 1];
  }

  function initCalc(root) {
    if (root.dataset.hycReady) return;
    root.dataset.hycReady = '1';

    var number = root.dataset.whatsapp;
    var state = { porte: 'casa_media', metodo: 'trad_cal_imper' };
    var q = function (sel) { return root.querySelector(sel); };
    var out = function (name) { return root.querySelector('[data-out="' + name + '"]'); };

    var bagsInput = q('[data-hyc-bags]');
    var precoCal = q('[data-hyc-preco="cal"]');
    var precoImper = q('[data-hyc-preco="imper"]');
    var precoCompleto = q('[data-hyc-preco="completo"]');
    var precoPlastImper = q('[data-hyc-preco="plast_imper"]');
    var precoCimento = q('[data-hyc-preco="cimento"]');
    var nome = q('[data-hyc-nome]');
    var empresa = q('[data-hyc-empresa]');
    var waBtn = q('[data-hyc-whatsapp]');
    var hint = q('[data-hyc-hint]');
    var hintDefault = hint.textContent;

    function aditivosPorSaco() {
      if (state.metodo === 'trad_cal_imper') return parseCurrencyInput(precoCal.value) + parseCurrencyInput(precoImper.value);
      if (state.metodo === 'cal_imper_plast') return parseCurrencyInput(precoCompleto.value);
      return parseCurrencyInput(precoPlastImper.value);
    }

    function compute() {
      var porte = PORTES[state.porte];
      var parsed = Number(bagsInput.value);
      var sacos = Number.isFinite(parsed) && parsed > 0 ? parsed : porte.sugestao;
      var cimento = parseCurrencyInput(precoCimento.value);

      // Hypocall: 5 sacos viram 4; a dose vai em cada saco que continua na massa
      var sacosHypo = Math.ceil(sacos * FATOR_CIMENTO_HYPO);
      var emb = embalagemPara(sacosHypo);

      var r = {
        sacos: sacos,
        sacosHypo: sacosHypo,
        sacosEconomizados: sacos - sacosHypo,
        embalagem: emb,
        metodoCusto: sacos * (cimento + aditivosPorSaco()),
        hypoCusto: sacosHypo * (cimento + emb.porSaco),
        metodoPeso: sacos * (PESO_SACO_CIMENTO + PESO_ADITIVOS[state.metodo]),
        hypoPeso: sacosHypo * (PESO_SACO_CIMENTO + PESO_DOSE_HYPO),
        metodoDias: sacos / SACOS_POR_DIA
      };
      r.hypoDias = r.metodoDias / PRODUTIVIDADE_HYPO;
      r.economia = r.metodoCusto - r.hypoCusto;
      r.pesoEliminado = r.metodoPeso - r.hypoPeso;
      r.diasEconomizados = r.metodoDias - r.hypoDias;
      r.economiaPct = r.metodoCusto > 0 ? (r.economia / r.metodoCusto) * 100 : 0;
      r.pesoPct = r.metodoPeso > 0 ? (r.pesoEliminado / r.metodoPeso) * 100 : 0;
      return r;
    }

    function render() {
      var porte = PORTES[state.porte];
      var r = compute();

      root.querySelectorAll('[data-porte]').forEach(function (b) {
        var on = b.dataset.porte === state.porte;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', String(on));
      });
      root.querySelectorAll('[data-metodo]').forEach(function (b) {
        var on = b.dataset.metodo === state.metodo;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', String(on));
      });

      out('sugestao').textContent = 'Sugestão para ' + porte.label.toLowerCase() + ': ' +
        porte.faixa[0].toLocaleString('pt-BR') + ' a ' + porte.faixa[1].toLocaleString('pt-BR') + ' sacos.';
      out('metodoCusto').textContent = formatCurrency(r.metodoCusto);
      out('metodoPeso').textContent = formatWeight(r.metodoPeso);
      out('metodoDias').textContent = formatDays(r.metodoDias);
      out('hypoCusto').textContent = formatCurrency(r.hypoCusto);
      out('hypoPeso').textContent = formatWeight(r.hypoPeso);
      out('hypoDias').textContent = formatDays(r.hypoDias);
      out('hypoDiasLabel').textContent = 'Tempo de argamassa com +15% de produtividade';
      out('hypoBase').textContent = r.sacosHypo.toLocaleString('pt-BR') + ' sacos de cimento no lugar de ' +
        r.sacos.toLocaleString('pt-BR') + ' · ' + r.embalagem.nome + ' a ' + formatCurrency(r.embalagem.porSaco) + ' por saco';
      out('economia').textContent = r.economia >= 0 ? formatCurrency(r.economia) : '−' + formatCurrency(-r.economia);
      out('economiaPct').textContent = r.economia >= 0
        ? r.economiaPct.toFixed(0) + '% a menos em cimento e aditivos'
        : 'Neste cenário o Hypocall custa mais em cimento e aditivos';
      out('pesoEliminado').textContent = formatWeight(r.pesoEliminado);
      out('pesoPct').textContent = r.pesoPct.toFixed(0) + '% de redução no peso';
      out('diasEconomizados').textContent = formatDays(r.diasEconomizados);
    }

    root.querySelectorAll('[data-porte]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.porte = b.dataset.porte;
        bagsInput.value = PORTES[state.porte].sugestao;
        render();
      });
    });

    root.querySelectorAll('[data-metodo]').forEach(function (b) {
      var select = function () { state.metodo = b.dataset.metodo; render(); };
      b.addEventListener('click', select);
      b.addEventListener('keydown', function (e) {
        if (e.target !== b) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(); }
      });
    });

    // Os campos de preço ficam dentro do card do método: não trocar a seleção ao clicar neles
    root.querySelectorAll('[data-hyc-stop]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.stopPropagation(); });
      el.addEventListener('keydown', function (e) { e.stopPropagation(); });
    });

    [precoCal, precoImper, precoCompleto, precoPlastImper, precoCimento].forEach(function (input) {
      input.addEventListener('input', function () {
        input.value = formatCurrencyInput(input.value);
        render();
      });
    });

    bagsInput.addEventListener('input', render);

    function setHint(msg) {
      hint.textContent = msg || hintDefault;
      hint.classList.toggle('is-error', !!msg);
    }
    [nome, empresa].forEach(function (input) {
      input.addEventListener('input', function () { setHint(''); });
    });

    waBtn.addEventListener('click', function () {
      var vazio = !nome.value.trim() ? nome : (!empresa.value.trim() ? empresa : null);
      if (vazio) {
        setHint('Preencha seu nome e o nome da empresa para continuar.');
        vazio.focus();
        return;
      }
      var r = compute();
      var msg = [
        'Ola, equipe Hypocall.',
        'Sou ' + (nome.value.trim() || 'Cliente') + ' da empresa ' + (empresa.value.trim() || 'Empresa nao informada') + '.',
        'Porte: ' + PORTES[state.porte].label + '.',
        'Sacos de cimento: ' + r.sacos + ' (com Hypocall, ' + r.sacosHypo + ' no traço 1:8).',
        'Metodo comparado: ' + METODOS[state.metodo] + '.',
        'Embalagem considerada: ' + r.embalagem.nome + '.',
        'Economia estimada em cimento e aditivos: ' + formatCurrency(r.economia) + '.',
        'Peso eliminado: ' + formatWeight(r.pesoEliminado) + '.',
        'Tempo economizado: ' + formatDays(r.diasEconomizados) + '.',
        'Quero falar com um especialista pelo WhatsApp.'
      ].join('\n');
      window.open(whatsappUrl(number, msg), '_blank', 'noopener,noreferrer');
    });

    render();
  }

  /* ---------------- Mapa de clientes (Leaflet + Firestore REST) ---------------- */

  var LEAFLET_CSS = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.css';
  var LEAFLET_JS = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/leaflet.min.js';
  var CLUSTER_JS = 'https://cdnjs.cloudflare.com/ajax/libs/leaflet.markercluster/1.5.3/leaflet.markercluster.min.js';
  var TOTAL_BRAZIL_STATES = 27;

  function firestoreValue(v) {
    if (!v) return undefined;
    if ('stringValue' in v) return v.stringValue;
    if ('doubleValue' in v) return Number(v.doubleValue);
    if ('integerValue' in v) return Number(v.integerValue);
    if ('booleanValue' in v) return v.booleanValue;
    return undefined;
  }

  function fetchCollection(projectId, apiKey, collection, fields) {
    var base = 'https://firestore.googleapis.com/v1/projects/' + encodeURIComponent(projectId) +
      '/databases/(default)/documents/' + encodeURIComponent(collection);
    var docs = [];

    function page(token) {
      var params = new URLSearchParams({ pageSize: '300', key: apiKey });
      fields.forEach(function (f) { params.append('mask.fieldPaths', f); });
      if (token) params.set('pageToken', token);
      return fetch(base + '?' + params.toString())
        .then(function (r) { if (!r.ok) throw new Error('firestore-' + r.status); return r.json(); })
        .then(function (json) {
          (json.documents || []).forEach(function (d) {
            var lead = { id: d.name.split('/').pop() };
            Object.keys(d.fields || {}).forEach(function (k) { lead[k] = firestoreValue(d.fields[k]); });
            docs.push(lead);
          });
          return json.nextPageToken ? page(json.nextPageToken) : docs;
        });
    }

    return page();
  }

  function trimmed(v) { return typeof v === 'string' ? v.trim() : ''; }
  function leadCity(l) { return trimmed(l.city) || trimmed(l.cidade) || trimmed(l.municipio); }
  function leadState(l) { return trimmed(l.state) || trimmed(l.uf) || trimmed(l.estado); }

  function initMap(root) {
    if (root.dataset.hycReady) return;
    root.dataset.hycReady = '1';

    var projectId = root.dataset.project;
    var apiKey = root.dataset.key;
    var showContact = root.dataset.showContact === 'true';
    var collections = (root.dataset.collections || 'leads').split(',').map(function (c) { return c.trim(); }).filter(Boolean);
    var canvas = root.querySelector('[data-hyc-map-canvas]');
    var status = root.querySelector('[data-hyc-map-status]');
    var out = function (name) { return root.querySelector('[data-out="' + name + '"]'); };

    function setStatus(msg) {
      status.hidden = !msg;
      status.textContent = msg || '';
    }

    if (!projectId || !apiKey) {
      setStatus('Mapa não configurado: preencha o Project ID e a API Key do Firebase nas configurações da seção.');
      return;
    }

    // Nome e telefone só são buscados quando a exibição no popup está ativada
    var fields = ['company', 'empresa', 'city', 'cidade', 'municipio', 'state', 'uf', 'estado', 'lat', 'lng'];
    if (showContact) fields = fields.concat(['name', 'nome', 'phone', 'telefone']);

    onVisible(root, function () {
      loadStyle(LEAFLET_CSS);
      var libs = loadScript(LEAFLET_JS).then(function () { return loadScript(CLUSTER_JS); });
      var data = Promise.all(collections.map(function (c) {
        return fetchCollection(projectId, apiKey, c, fields).catch(function (err) {
          console.warn('[Hypocall] Falha ao ler a coleção ' + c + ':', err);
          return null;
        });
      }));

      Promise.all([libs, data]).then(function (res) {
        var results = res[1];
        if (results.every(function (r) { return r === null; })) {
          setStatus('Não foi possível carregar os clientes do mapa.');
        }
        renderMap(results.filter(Boolean).reduce(function (a, b) { return a.concat(b); }, []));
      }).catch(function (err) {
        console.warn('[Hypocall] Falha ao carregar o mapa:', err);
        setStatus('Não foi possível carregar o mapa.');
      });
    }, '200px');

    function renderMap(leads) {
      var L = window.L;

      // Métricas (iguais ao site original: contam todos os contatos)
      var cities = {};
      var states = {};
      leads.forEach(function (l) {
        var c = leadCity(l);
        var s = leadState(l);
        if (c) cities[c + '-' + s] = true;
        if (s) states[s.toUpperCase()] = true;
      });
      var totalCities = Object.keys(cities).length;
      out('presenca').textContent = Math.round((Object.keys(states).length / TOTAL_BRAZIL_STATES) * 100) + '%';
      out('cidades').textContent = totalCities + (totalCities > 0 ? '+' : '');
      out('associados').textContent = String(leads.length);

      var map = L.map(canvas, {
        center: [-16.5, -57],
        zoom: 3,
        minZoom: 3,
        maxZoom: 12,
        zoomControl: false,
        scrollWheelZoom: false
      });
      L.control.zoom({ position: 'topleft' }).addTo(map);
      L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> | &copy; <a href="https://carto.com/">CARTO</a>'
      }).addTo(map);

      var cluster = L.markerClusterGroup({
        maxClusterRadius: 40,
        showCoverageOnHover: false,
        spiderfyOnMaxZoom: true,
        iconCreateFunction: function (c) {
          var count = c.getChildCount();
          var size = count >= 100 ? 42 : count >= 10 ? 36 : 30;
          return L.divIcon({
            className: '',
            html: '<div class="hyc-cluster' + (count >= 100 ? ' is-big' : '') + '" style="width:' + size + 'px;height:' + size +
              'px;font-size:' + (count >= 100 ? 10 : 11) + 'px">' + count + '</div>',
            iconSize: [size, size],
            iconAnchor: [size / 2, size / 2]
          });
        }
      });

      var dot = L.divIcon({ className: '', html: '<div class="hyc-dot"></div>', iconSize: [12, 12], iconAnchor: [6, 6], popupAnchor: [0, -8] });

      leads.forEach(function (l) {
        if (typeof l.lat !== 'number' || typeof l.lng !== 'number' || isNaN(l.lat) || isNaN(l.lng)) return;
        var city = leadCity(l) || 'Cidade não informada';
        var uf = leadState(l);
        var company = trimmed(l.company) || trimmed(l.empresa);
        var html = '<div class="hyc-map-popup" style="min-width:180px">';
        if (showContact) {
          html += '<p class="hyc-pop-name">' + escapeHtml(trimmed(l.name) || trimmed(l.nome) || 'Cliente Hypocall') + '</p>';
          html += '<p class="hyc-pop-sub">' + escapeHtml(company || 'Empresa não informada') + '</p>';
        } else {
          html += '<p class="hyc-pop-name">' + escapeHtml(company || 'Cliente Hypocall') + '</p>';
        }
        html += '<p class="hyc-pop-sub" style="margin-top:4px">' + escapeHtml(city) + (uf ? '/' + escapeHtml(uf) : '') + '</p>';
        if (showContact) {
          var phone = trimmed(l.phone) || trimmed(l.telefone);
          if (phone) html += '<p class="hyc-pop-phone">' + escapeHtml(phone) + '</p>';
        }
        html += '</div>';
        cluster.addLayer(L.marker([l.lat, l.lng], { icon: dot }).bindPopup(html));
      });

      map.addLayer(cluster);
      // Libera o zoom pelo scroll só depois de clicar no mapa (não prende a rolagem da página)
      map.once('click', function () { map.scrollWheelZoom.enable(); });
      root._hycMap = map;
    }
  }

  /* ---------------- Boot ---------------- */

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-hyc-calc]').forEach(initCalc);
    scope.querySelectorAll('[data-hyc-consultor]').forEach(initConsultor);
    scope.querySelectorAll('[data-hyc-toggle]').forEach(initToggle);
    scope.querySelectorAll('[data-hyc-map]').forEach(initMap);
  }

  window.Hypocall = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-hyc-map]').forEach(function (m) {
      if (m._hycMap) m._hycMap.remove();
    });
  });
})();
